import styled from 'styled-components';

interface ButtonProps {
  outline?: boolean;
}

export const Button = styled.button<ButtonProps>`
  width: 178px;
  height: 40px;
  border: 1px solid white;
  color: white;
  background: none;
  border-radius: 100px;

  font-family: Montserrat;
  font-weight: bold;
  font-size: 16px;

  cursor: pointer;

  a {
    text-decoration: none;
    color: unset;
  }
`;
